import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItemText,
  Card,
  CardContent,
  TextField,
  Avatar,
  Box,
  IconButton,
  ListItemButton,
  Button,
  Badge,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import EditIcon from "@mui/icons-material/Edit"; // ✨ Added
import { useNavigate } from "react-router-dom";


const API = "https://course-selling-backend-2-rr1n.onrender.com";

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get(`${API}/api/users/me`, {
          headers: { "x-auth-token": token },
        });
        setUser(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    axios
      .get(`${API}/api/courses`)
      .then((res) => setCourses(res.data))
      .catch((err) => console.error(err));

    fetchUser();
  }, []);


  const handleViewCourse = (courseId) => {
    navigate(`/viewcourse/${courseId}`);
    console.log("course id:", courses._id);
  };

  if (!user) return <h2>Loading Dashboard...</h2>;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          width: 250,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 250,
            bgcolor: "#0D47A1",
            color: "white",
            borderRight: "none",
            boxShadow: 3,
          },
        }}
      >
        <Box
          sx={{
            p: 3,
            textAlign: "center",
            borderBottom: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            Medby Academy
          </Typography>
          <Avatar
            sx={{ bgcolor: "#1976d2", width: 60, height: 60, mx: "auto", mt: 2 }}
          >
            {user.name[0]}
          </Avatar>
          <Typography sx={{ mt: 1 }}>{user.name}</Typography>
        </Box>

        <List sx={{ mt: 3 }}>
          <ListItemButton
            sx={{ mb: 1, borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
          >
            <DashboardIcon sx={{ mr: 2 }} /> <ListItemText primary="Dashboard" />
          </ListItemButton>

          <ListItemButton
            sx={{ mb: 1, borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
          >
            <Link
              to="/mycourses"
              style={{ textDecoration: "none", color: "inherit", width: "100%" }}
            >
              <SchoolIcon sx={{ mr: 2 }} /> My Courses
            </Link>
          </ListItemButton>

          {/* ✅ Admin Only Options */}
          {user.role === "admin" && (
            <>
              <ListItemButton
                sx={{ mb: 1, borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
              >
                <Link
                  to="/course-upload"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    width: "100%",
                  }}
                >
                  <UploadFileIcon sx={{ mr: 2 }} /> Upload Course
                </Link>
              </ListItemButton>

              <ListItemButton
                sx={{ mb: 1, borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
              >
                <Link
                  to="/edit"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    width: "100%",
                  }}
                >
                  <EditIcon sx={{ mr: 2 }} /> Edit Course Info
                </Link>
              </ListItemButton>
            </>
          )}

          <ListItemButton
            sx={{ mb: 1, borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
          >
            <ListItemText primary="Profile" />
          </ListItemButton>

          <ListItemButton
            sx={{ borderRadius: 2, "&:hover": { bgcolor: "#1976d2" } }}
            onClick={() => {
              localStorage.removeItem("token");
              window.location.href = "/#home";
            }}
          >
            <LogoutIcon sx={{ mr: 2 }} /> Logout
          </ListItemButton>
        </List>
      </Drawer>

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 4, bgcolor: "#f0f2f5" }}>
        <AppBar
          position="static"
          sx={{ mb: 4, bgcolor: "white", color: "black", boxShadow: 3 }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h6">Welcome, {user.name} 👋</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <TextField size="small" placeholder="Search courses..." />
              <IconButton>
                <Badge badgeContent={3} color="error">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <Avatar sx={{ bgcolor: "#1976d2" }}>{user.name[0]}</Avatar>
            </Box>
          </Toolbar>
        </AppBar>

        <Typography variant="h5" gutterBottom fontWeight="bold">
          All Available Courses
        </Typography>
        <Grid container spacing={4}>
          {courses.map((card, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: 350,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  borderRadius: 4,
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                  },
                }}
              >
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    p: 3,
                  }}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={3}>
                    {card.desc}
                  </Typography>

                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#2e7d32 !important",
                      color: "white",
                      borderRadius: "25px",
                      px: 3,
                      "&:hover": { backgroundColor: "#1b5e20 !important" },
                    }}
                    onClick={() => handleViewCourse(card._id)}
                  >
                    View Details
                  </Button>




                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
